// General formatting and DOM helpers — identical in both portals
// Source: apps/*/src/util/util.tsx

export function getWindowSize(): { height: number; width: number } {
  return {
    height: window.innerHeight,
    width: window.innerWidth,
  };
}

export const getCookieValueByName = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

// Uses advisor portal's debounced version (prevents duplicate redirects)
let loginRedirectTimeoutId: number | null = null;

export const navigateToLogin = (): void => {
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/login"
  ) {
    return;
  }
  if (loginRedirectTimeoutId !== null) {
    return;
  }
  loginRedirectTimeoutId = window.setTimeout(() => {
    loginRedirectTimeoutId = null;
    window.location.assign("/");
  }, 200);
};

export const removeSpacesAndStrs = (
  str: string,
  removeStrs: string[],
): string => {
  if (typeof str !== "string") {
    throw new Error("Input must be a string");
  }
  removeStrs.forEach((keyword) => {
    const regex = new RegExp(`\\b${keyword}\\b`, "g");
    str = str.replace(regex, "");
  });
  return str.replace(/\s+/g, "");
};

export const getValueFromEvent = (
  value: string | number | null | undefined,
): number => {
  if (typeof value === "string") {
    return parseFloat(value.replace(/,/g, "")) || 0;
  }
  return value || 0;
};

export const getValueProps = (
  value: number | string | null | undefined,
): { value: string } => ({
  value: value != null ? value.toString() : "",
});

export const numberFormatter = (
  value: string | number | undefined,
): string => {
  if (value === undefined || value === null) return "";
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const numberParser = (value: string | undefined): number => {
  if (value === undefined || value === null) return 0;
  return parseFloat(value.replace(/\$\s?|(,*)/g, "")) || 0;
};
